import Axios from "axios";
import storage from "@/utils/storage";

const API_URL =
  process.env.REACT_APP_BASE_API_URL || "https://opigo.co.in/api/v1";
const API_KEY =
  process.env.REACT_APP_API_KEY || "2a921b5b8e212d50b207bfa55c0a5101";

export const axios = Axios.create({
  baseURL: API_URL,
});

axios.interceptors.request.use((config) => {
  const token = storage.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (API_KEY) {
    config.headers["X-Opigo-Api-Key"] = API_KEY;
  }
  config.headers.Accept = "application/json";
  return config;
});

axios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (window.isRedeem) {
      return Promise.resolve(error);
    }
    return Promise.reject(error);
  },
);
